import React, { useState, useEffect} from 'react';
import { configData } from "../config";
import { useParams } from 'react-router-dom';
import ReactDOM from "react-dom/client";
import Loading from './Loading';
import { Helmet } from 'react-helmet';
import DatePicker from 'react-datepicker';
import { format } from "date-fns";
import moment from 'moment-timezone';
import SweetAlert from "react-sweetalert2";	
moment.tz.setDefault('America/Los_Angeles');

function ScheduleTaskMore() {

    var {uid} = useParams();
   var currentdate = new Date().toLocaleDateString();
         const currentDatePST = moment().tz('America/Los_Angeles').format('MM-DD-YYYY');
          const currentDateTimePST = moment().tz('America/Los_Angeles').format('MM-DD-YYYY h:mm:ss A');
          const currentDateCustomTimePST = moment().tz('America/Los_Angeles').set({ hour: 1, minute: 0, second: 0 }).format('MM-DD-YYYY hh:mm:ss A');
       var currenttime = new Date().toLocaleTimeString();
       var currentdatetime = currentdate+' '+currenttime;
    var currenttime = new Date().toLocaleTimeString();
    var currentdatetime = currentdate+' '+currenttime;
    const [isLoading, setIsLoading] = useState(true);
    const[salespersonList, setSalespersonList] = useState({});
    const app_url = configData.APP_URL;
    const [userDetails, setUserDetails] = useState({});
    const[userRoles,setUserRoles] = useState([]);
      const[userLoggedInRoles,setUserLoggedInRoles] = useState([]);
     const [taskformData, setTaskFormData] = useState({
            loggedin_uid: localStorage.getItem('drupal_uid'),
            drupal_uid: uid,
            salesperson: localStorage.getItem('drupal_uid'),
            due_date: currentDateCustomTimePST,
            priority: 'Medium',
            repeat: '',
            frequency: '',
            spantype: 'Day',
            subject: '',
            details: '',
            apply_courses: '',
        });
         const [viewtaskformData, setViewTaskFormData] = useState({
            loggedin_uid: localStorage.getItem('drupal_uid'),
            drupal_uid: uid,
            id:'',
            salesperson: '',
            due_date: '',
            priority: 'Medium',
            repeat: '',
            frequency: '',
            spantype: 'Day',
            subject: '',
            details: '',
            apply_courses: '',
        });
         const [eventformData, setEventFormData] = useState({
                loggedin_uid: localStorage.getItem('drupal_uid'),
                drupal_uid: uid,
                subject: 'Out Bound Call',
                details: ''
            });
    const [taskdetailedview, setTaskDetailedView] = useState({});
    const [tasklist, setTaskList] = useState({});
        
    
    const[showTaskModal, setShowTaskModal] = useState(false);
    const[showViewTaskModal, setShowViewTaskModal] = useState(false);
    const[showEventModal, setShowEventModal] = useState(false);
  
     const handleChange = (e) => {
        const { name, value } = e.target;
        
        setEventFormData({ ...eventformData, [name]: value });
    };
    
     const handleTaskChange = (e) => {
            const { name, value } = e.target;
           
            setTaskFormData({ ...taskformData, [name]: value });
            console.log(taskformData);
        };
        const handleViewTaskChange = (e) => {
            const { name, value } = e.target;
          
            setViewTaskFormData({ ...viewtaskformData, [name]: value });
            console.log(viewtaskformData);
        };
        const handleDateChange = (date) => {
       
        if (date) {
          const formattedDate = format(date, "MM-dd-yyyy h:mm:ss aa");
                setTaskFormData({ ...taskformData, ['due_date']: formattedDate });
          
          // You can now use formattedDate for your application logic
        }
      };
      const handleViewTaskDateChange = (date) => {
       
        if (date) {
          const formattedDate = format(date, "yyyy-MM-dd HH:mm:ss"); // Example: 2025-06-21 11:03:00
           setViewTaskFormData({ ...viewtaskformData, ['due_date']: formattedDate });
          
          // You can now use formattedDate for your application logic
        }
      };
      const isPastDateTimeInPST = (dateTimeToCheck) => {
        // Get current datetime in PST
        const currentPST = moment.tz("America/Los_Angeles");
        
        // Parse and keep the datetime to check in PST for comparison
        const dateTimeToCheckPST = moment.tz(dateTimeToCheck, "America/Los_Angeles");
        
        return dateTimeToCheckPST.isBefore(currentPST);
      };
        useEffect(() => {
        Promise.all([
       gettasklist(),
       getuserdetails(),
        getsalespersonlist(),
        getloggedinuserroles()]).then(() => {
     
      setIsLoading(false);
        })
      },[]);
        const handleModalOpen = (modalname) => {
        if(modalname == 'add_task') {
        setShowTaskModal(true);
        }
       if(modalname == 'add_event_log') {
        setShowEventModal(true);
        }
        
    };
    const handleViewModalOpen = async (modalname,eventid) => {
        
        if(modalname == 'view_task') {
        setShowViewTaskModal(true);
        if(uid && !Number.isNaN(uid)) {
        
                try {
                const response =  await fetch(
                app_url+'smwwtask/getusertaskdetailedview?uid='+uid+'&taskid='+eventid,
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
                )
                const responsedata =  await response.json();
                
                if(responsedata.data.msg == "Success") {
                    
                    setTaskDetailedView(responsedata.data.result);
                    setViewTaskFormData({ 
                      loggedin_uid: localStorage.getItem('drupal_uid'),
                      drupal_uid: uid,
                      id:responsedata.data.result.id,
                      salesperson: responsedata.data.result.field_assignee,
                      due_date: responsedata.data.result.field_due_date,
                      priority: responsedata.data.result.field_priority,
                      repeat: responsedata.data.result.field_repeat,
                      frequency: responsedata.data.result.field_frequency,
                      spantype: responsedata.data.result.field_frequency_type,
                      subject: responsedata.data.result.title,
                      details: responsedata.data.result.body,
                      apply_courses: responsedata.data.result.field_apply_courses,
                    });
                    
                } 
                } catch (err) {
                }
            }
        }
        
    };
    const handleModalClose = (modalname) => {
         if(modalname == 'add_task') {
        setShowTaskModal(false);
        }
        
        if(modalname == 'add_event_log') {
        setShowEventModal(false);
        }
        if(modalname == 'view_task') {
        setShowViewTaskModal(false);
        setTaskDetailedView({});
        }
        
    };
   const handleSubmit = async event => {
       //const formErrors = validate(eventformData);

      //if (Object.keys(formErrors).length == 0) {
        event.preventDefault();
        const postData = eventformData;
        const response = await fetch(app_url + 'smwweventlog/addevent', {
        method: 'POST',
        body: JSON.stringify(postData),
        headers: {
          'Content-Type': 'application/json',
        },
      });
        const data = await response.json();
        if(data.data.msg == "Success") {
            setShowEventModal(false);
          
        }
      //}
    };

 async function getsalespersonlist() {
    if(uid && !Number.isNaN(uid)) {
        
         try {
            const response = await fetch(
                app_url+'viewprofile/getsalespersonlist',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setSalespersonList(responsedata.data.result);
               
            } 
        } catch (err) {
            
         }
        }
  }
  async function getuserdetails() {
    if(uid && !Number.isNaN(uid)) {
        
         try {
            const response = await fetch(
                app_url+'smwweventlog/getuserdetails?uid='+uid,
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data.msg == "Success") {
                setUserDetails(responsedata.data.result);
                setUserRoles(responsedata.data.roles);
            } 
        } catch (err) {
            
         }
        }
  }
  async function getloggedinuserroles() {
    if(uid && !Number.isNaN(uid)) {
        
         try {
            const response = await fetch(
                app_url+'viewprofile/getuserloggedinrolesid',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data.result == "Success") {
              
                setUserLoggedInRoles(responsedata.data.roles);
            } 
        } catch (err) {
            
         }
        }
  }
  async function gettasklist() {
    if(uid && !Number.isNaN(uid)) {
        
         try {
            const response = await fetch(
                app_url+'smwwtask/getuserfulltasklist?uid='+uid,
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data.msg == "Success") {
                setTaskList(responsedata.data.result);
            } 
        } catch (err) {
            
         }
        }
  }
  const addtaskvalidate = (data) => {
  const newErrors = {};

  if(!data.subject.trim()) { 
    alert('Event Title is required');
    
    newErrors.subject = 'Event Title is required';
   
  }
  else if(!data.due_date.trim()) { 
    alert('Due Date is required');
    
    newErrors.due_date = 'Due Date is required';
   
  }
  

  return newErrors;
  };
  const handleTaskSubmit = async event => {
        event.preventDefault();
        const formErrors = addtaskvalidate(taskformData);

      if (Object.keys(formErrors).length == 0) {
        const postData = taskformData;
        const response = await fetch(app_url + 'smwwtask/addtask', {
        method: 'POST',
        body: JSON.stringify(postData),
        headers: {
          'Content-Type': 'application/json',
        },
      });
        const data = await response.json();
        if(data.data.msg == "Success") {
            setShowTaskModal(false);
            setTaskList(data.data.result);
        }
      }
    };
    
    const handleViewTaskSubmit = async (value) => {
       
        const postData = {
          formData: viewtaskformData,
          id: value
          };
        const response = await fetch(app_url + 'smwwtask/updatetask', {
        method: 'POST',
        body: JSON.stringify(postData),
        headers: {
          'Content-Type': 'application/json',
        },
      });
        const data = await response.json();
        if(data.data.msg == "Success") {
            setShowViewTaskModal(false);
            setTaskList(data.data.result);
        }
    };
     const handleTaskComplete = async (value) => {

        const confirmed = window.confirm('Are you sure you want to mark this task as complete? This cannot be undone.');

          if (confirmed) {
           const postData = {
            uid:uid,
            id:value
          };
          try {
            const response = await fetch(app_url + 'smwwtask/completetask', {
            method: 'POST',
            body: JSON.stringify(postData),
            headers: {
            'Content-Type': 'application/json',
            },
            });
            const data = await response.json();
            if(data.data.msg === "Success") {
               
               gettasklist();
            }
          } catch (err) {
            
        }
        } else {
          // User clicked "Cancel"
      
        }
       
    };
    const handleTaskCompleteWithouConfirm = async (value) => {
        const postData = {
            uid:uid,
            id:value
          };
          try {
            const response = await fetch(app_url + 'smwwtask/completetask', {
            method: 'POST',
            body: JSON.stringify(postData),
            headers: {
            'Content-Type': 'application/json',
            },
            });
            const data = await response.json();
            if(data.data.msg === "Success") {
               
               setTaskList(data.data.result);
            }
          } catch (err) {
            
        }
       
       
    };
     return (
       <>
   {isLoading ? (
        <Loading />
      ) : (
        <div id="main">
 
            <div class="left"></div>

            <div class="center left-center add-to-earena-page">
                <Helmet><title>More Tasks</title></Helmet>
              
				 <div className='task_result_wrapper'>									  
                 <table id="task_result" width="382" border="0" cellpadding="0" class="white" cellspacing="0">
                  <tbody><tr>
                    <td height="17" colspan="9" valign="top" align="left" class="infobar">
					
                    					</td>
                    <td align="right" class="infobar desktop_add_task">
                                            <a href style={{'cursor':'pointer'}} onClick={() => handleModalOpen('add_task')} title="Add Task" class="thickbox">
                          <img src="/basic/web/images/newTask.gif" alt="Create New Task" border="0" /></a>&nbsp;
                                        </td>
                  </tr>
                  <tr bgcolor="CCCCCC">
                    <td width="30">&nbsp;</td>
                    <td width="70"><b>Created</b></td>
                    <td><b>Sales Person</b></td>
                    <td width="70"><b>Due Date</b></td>
                    <td width="60"><b>Priority</b></td>
                    <td><b>Who</b></td>
                    <td><b>Acct</b></td>
                   
                    <td width=""><b>Subject</b></td>
                    <td><b>Course/Conference</b></td>
                    <td width="30">&nbsp;</td>
                  </tr>
                  {tasklist.length > 0 ? (
                    <>
                      {tasklist.map((item, index) => {
                        const isPast = isPastDateTimeInPST(item['field_due_date']);
                        return <>
                          <tr bgcolor={item['bg_color']}>
                             {isPast ? (
                              <td><a href style={{'cursor':'pointer'}} onClick={() => handleTaskCompleteWithouConfirm(item['id'])} title="Mark Complate"><img src="/basic/web/images/markascomplete.gif" alt="Mark as Complete" border="0" /></a></td>
                             ):(

                               <td><a href style={{'cursor':'pointer'}} onClick={() => handleTaskComplete(item['id'])} title="Mark Complate"><img src="/basic/web/images/markascomplete.gif" alt="Mark as Complete" border="0" /></a></td>
                             )
                            }
                            <td>{item['created']}</td>
                             <td><a style={{'cursor':'pointer'}} href={"/user/"+item['field_assignee_uid']}>{item['field_assignee']}</a></td>
                            <td>{item['field_due_date']}</td>
                            <td>{item['field_priority']}</td>
                            <td><a style={{'cursor':'pointer'}} href={"/user/"+item['who_uid']}>{item['who']}</a></td>
                             <td><a href style={{'cursor':'pointer'}} onClick={() => handleModalOpen('add_event_log')} title="Event Log" class="thickbox"><img src="/basic/web/images/outboundcall.gif" alt="Out Bound Call" title="Out Bound Call" border="0" align="top" /></a>
                                                            {userLoggedInRoles.includes(configData.ROLE_AGENT) && userRoles.includes(configData.ROLE_ATHLETE) ? (
                                                            <a style={{'cursor':'pointer'}} href={"/view_athlete/"+uid}><img src="/basic/web/images/ViewOwnerProfile.gif" alt="View Profile" border="0" align="top" />&nbsp;{item['owner']}</a>
                                                            ): (
                                                              <a style={{'cursor':'pointer'}} href={"/user/"+uid}><img src="/basic/web/images/ViewOwnerProfile.gif" alt="View Profile" border="0" align="top" />&nbsp;{item['owner']}</a>
                                                            )}
                                                            </td>
                            <td><a href onClick={() => handleViewModalOpen('view_task',item['id'])} title="View Task" class="thickbox"><img src="/basic/web/images/viewtaskdetails.gif" alt="View Task Details" border="0" align="top" />{item['title']}</a></td>
                            <td>{item['field_apply_courses']}</td>
                            <td align="right" width="25">&nbsp;</td>
                            
                          </tr>
                        </>
                    
                      })}  
                    </>
                  ) : (
                      <><tr id="no_events"><td colspan="10"><b>There are no pending items in your task schedule</b></td></tr></>
                  )}
                                            
                        </tbody></table></div>
       {/* {showTaskModal && (           
         <div id="myModal" className="modal addtask">
           <div className="modal-content">
             <div class="modal-header">
               
               <h2>Add Task</h2>
               <span class="close"  onClick={() => handleModalClose('add_task')}>&times;</span>
             </div>
             <div class="modal-body"> */}
              <SweetAlert
              show={showTaskModal}
              title="Add Task"
              showConfirmButton={false}
              showCloseButton={true}
              heightAuto={false}
              didClose={() => handleModalClose('add_task')}		 
              > 
               <form id="task-add" className="sweetalert-task-add" method="post">
                 <table id="add-task-table">
                   <tbody><tr><td>Sales Person:</td>
                     <td>
                     <select id="salesperson" name="salesperson" value={taskformData.salesperson} onChange={handleTaskChange}>
                       <option value="0"></option>
                       {salespersonList.length > 0 && (
                       <>
                         {salespersonList.map((item, index) => {
                           return <>
                             {item['uid'] != null && (
                               <><option value={item['uid']}>{item['name']}</option></>
                             )}
                           </>
                           
                         })}  
                  
                       </>
                       )}
                     </select>
                     </td>
                   </tr>
                 <tr>
                   <td><strong>Due Date:</strong></td>
                  <td>
                     <DatePicker
                           id="datetime"
                           selected={taskformData.due_date ? new Date(taskformData.due_date) : null}
                           onChange={handleDateChange}
                           placeholderText=""
                           dateFormat="MM/dd/yyyy h:mm aa"
                           showTimeSelect
                           timeFormat="HH:mm"
                           timeIntervals={1}
                           className="form-input"
                         />
                     </td>
                 </tr>
                 <tr>
                  <td><strong>Priority:</strong></td>
                  <td><select value={taskformData.priority} name="priority" onChange={handleTaskChange}>
                      <option value="High">High</option>
                      <option value="Medium" selected="">Medium</option>
                      <option value="Low">Low</option>
                  </select></td>
                 </tr>
                 {/*
                 <tr>
                  <td><strong>Recurrence:</strong></td>
                  <td><input type="checkbox" name="repeat" id="repeat" value="1" onChange={handleTaskChange}/>
                  <label for="repeat" >Repeat</label>
                  <input type="text" name="frequency" defaultValue="1" size="3" maxlength="1" onChange={handleTaskChange}/>
                  times per
                  <select name="spantype" onChange={handleTaskChange}>
                      <option value="Day">Day</option>
                      <option value="Week">Week</option>
                      <option value="Month">Month</option>
                      <option value="Year">Year</option>
                  </select>
                   </td>
                 </tr>
                 */}
                 <tr>
                  <td><strong>Event Title:</strong></td>
                  <td><input type="text" name="subject" id="subject" onChange={handleTaskChange}/></td>
                 </tr>
                 <tr>
                  <td ><strong>Details:</strong></td>
                  <td><textarea name="details" cols="40" rows="7" onChange={handleTaskChange}></textarea></td>
                 </tr>
                 <tr>
                   <td>Course/Conference:</td>
                   <td><textarea name="apply_courses" cols="40" rows="3" onChange={handleTaskChange}></textarea></td>
                 </tr>
                 <tr>
                   <td> </td><td className="my-sales-task-submit">
                     <input type="button" id="btn" name="btn" value="Save" onClick={handleTaskSubmit}/>
                   </td>
                 </tr>
               </tbody>
               </table>
               </form>
           {/* </div> */}
           <div class="modal-footer">
            
           </div>
          </SweetAlert>
         {/* </div>
      
       </div>
         )} */}
       {showEventModal && (           
<div id="myModal" class="modal add-event-modal">

 
  <div class="modal-content">
    <div class="modal-header">
      
      <h2>Add Event Log</h2>
      <span class="close"  style={{'cursor':'pointer'}} onClick={() => handleModalClose('add_event_log')}>&times;</span>
    </div>
    <div class="modal-body">
      <form id="athlete_eventlog" method="post">
       
        <p>
 Entering event for: <strong>{userDetails.user_name}</strong><br />
	By User: <strong>{userDetails.loggedin_user_name}</strong><br />
	Start Time:{currentDateTimePST}</p>
<p>
	<strong>Subject:</strong>
	<input type="text" name="subject" defaultValue="Out Bound Call" onChange={handleChange} />
</p>
<p>
	<strong>Details:</strong>
	<textarea name="details" cols="40" rows="7" onChange={handleChange} ></textarea>
</p>
<p>
	
	<input type="button" id="btn" name="btn" value="Save" onClick={handleSubmit}/>
</p>
</form>
    </div>
    <div class="modal-footer">
     
    </div>
  </div>

</div>
  )}

         {showViewTaskModal && (           
         <div id="myModal" className="modal viewtask">
           <div class="modal-content">
             <div class="modal-header">
               
               <h2>View Task</h2>
               <span class="close"  onClick={() => handleModalClose('view_task')}>&times;</span>
             </div>
             <div class="modal-body">
               <form id="task-add" method="post">
                 <table id="add-task-table">
                   <tbody>
                     <tr><td>Scheduled task bound to:</td><td>{taskdetailedview.field_owner_ac_target_id}</td></tr>
                     <tr><td>Created:</td><td>{taskdetailedview.created_at}</td></tr>
                     <tr><td>By User:</td><td>{taskdetailedview.uid}</td></tr>
                     <tr><td>Sales Person:</td>
                     <td>
                     <select id="salesperson" name="salesperson" onChange={handleViewTaskChange} value={viewtaskformData.salesperson}>
                       <option value="0"></option>
                       {salespersonList.length > 0 && (
                       <>
                         {salespersonList.map((item, index) => {
                           return <>
                             {item['uid'] != null && (
                               <><option value={item['uid']}>{item['name']}</option></>
                             )}
                           </>
                           
                         })}  
                  
                       </>
                       )}
                     </select>
                     </td>
                   </tr>
                 <tr>
                   <td><strong>Due Date:</strong></td>
                  <td>
                     <DatePicker
                           id="datetime"
                           selected={viewtaskformData.due_date ? new Date(viewtaskformData.due_date) : null}
                           onChange={handleViewTaskDateChange}
                           placeholderText=""
                           dateFormat="MM/dd/yyyy h:mm aa"
                           showTimeSelect
                           timeFormat="HH:mm"
                           timeIntervals={1}
                           className="form-input"
                           defaultValue={viewtaskformData.field_due_date}
                         />
                     </td>
                 </tr>
                 <tr>
                  <td><strong>Priority:</strong></td>
                  <td><select name="priority" value={viewtaskformData.priority} onChange={handleViewTaskChange} >
                      <option value="High">High</option>
                      <option value="Medium" selected="">Medium</option>
                      <option value="Low">Low</option>
                  </select></td>
                 </tr>
                 {/*
                 <tr>
                  <td><strong>Recurrence:</strong></td>
                  <td><input type="checkbox" name="repeat" id="repeat"  onChange={handleViewTaskChange} defaultValue={taskdetailedview.field_repeat}/>
                  <label for="repeat" >Repeat</label>
                  <input type="text" name="frequency" defaultValue="1" size="3" maxlength="1" onChange={handleViewTaskChange}/>
                  times per
                  <select name="spantype" defaultValue={taskdetailedview.field_frequency_type} onChange={handleViewTaskChange}>
                      <option value="Day">Day</option>
                      <option value="Week">Week</option>
                      <option value="Month">Month</option>
                      <option value="Year">Year</option>
                  </select>
                   </td>
                 </tr>
                 */}
                 <tr>
                  <td><strong>Event Title:</strong></td>
                  <td><input type="text" name="subject" defaultValue={viewtaskformData.subject} id="subject" onChange={handleViewTaskChange}/></td>
                 </tr>
                 <tr>
                  <td ><strong>Details:</strong></td>
                  <td><textarea name="details" cols="40" rows="7" defaultValue={viewtaskformData.details} onChange={handleViewTaskChange}></textarea></td>
                 </tr>
                 <tr>
                   <td>Course/Conference:</td>
                   <td><textarea name="apply_courses" cols="40" rows="3" defaultValue={viewtaskformData.apply_courses} onChange={handleViewTaskChange}></textarea></td>
                 </tr>
                 <tr>
                   <td> </td><td className="sales-task-savebtn">
                     <input type="button" id="btn" name="btn" value="Save" onClick={()=>handleViewTaskSubmit(taskdetailedview.id)}/>
                   </td>
                 </tr>
               </tbody>
               </table>
               </form>
           </div>
           <div class="modal-footer">
            
           </div>
         </div>
       
       </div>
         )}
            </div>
        </div>
        )}
    </>
    
      );
      
}
export default ScheduleTaskMore;